import { AccountData } from '../../../store/Accounts';
import { PriceBenchMark } from '../../../store/PriceBenchMark';
import { Team } from '../../../store/Team';
import { InventoryAsset, PortalUserData, SupportCasesItem } from '../../../types';
import { WorkflowOrder } from '../../../Api/Orders/ordersApi';
import { IconType } from '../../Atoms/Icon';
import { Text } from '../../Atoms/Text';

export type ComponentName =
  | 'inventory'
  | 'workflow-order'
  | 'support'
  | 'user'
  | 'team'
  | 'account'
  | 'sub-agent'
  | 'project-asset'
  | 'project'
  | 'benchmark';
export interface DetailsMeta {
  title?: string;
  subtitleKey?: string;
  titleKey?: string;
  componentName?: ComponentName;
  icon?: IconType;
  idKey?: string;
  error?: string;
}

export const getComponentName = (pathname: string) => {
  if (/\/inventory-optimization/.test(pathname)) return 'benchmark';
  if (/\/inventory/.test(pathname)) return 'inventory';
  if (/\/orders/.test(pathname)) return 'workflow-order';
  if (/\/support-cases/.test(pathname)) return 'support';
};

export const getMetaData = (name?: ComponentName): DetailsMeta => {
  if (!name) return { error: 'invalid component name' };

  switch (name) {
    case 'support':
      return {
        title: 'Support Case',
        subtitleKey: 'caseNumber',
        componentName: 'support'
      };
    case 'inventory':
      return {
        title: 'Inventory Details',
        subtitleKey: 'address',
        componentName: 'inventory'
      };
    case 'workflow-order':
      return {
        title: 'Order Request Details',
        subtitleKey: 'name',
        componentName: 'workflow-order'
      };
    case 'user':
      return {
        title: 'User',
        subtitleKey: 'first_name',
        componentName: 'user'
      };
    case 'team':
      return {
        subtitleKey: 'name',
        titleKey: 'account_name',
        componentName: 'team'
      };
    case 'account':
      return {
        title: 'Account Details',
        subtitleKey: 'name',
        componentName: 'account'
      };
    case 'sub-agent':
      return {
        title: 'Sub-Agent Details',
        subtitleKey: 'name',
        componentName: 'account'
      };
    case 'project-asset':
      return {
        title: 'Inventory Details',
        subtitleKey: 'address',
        componentName: 'project-asset'
      };
    case 'benchmark':
      return {
        title: 'Optimization Details',
        subtitleKey: 'name',
        componentName: 'benchmark'
      };
    default:
      return {
        error: 'invalid component name'
      };
  }
};

export const subTitle = (
  componentName: ComponentName,
  data: InventoryAsset | SupportCasesItem | PortalUserData | Team | AccountData | PriceBenchMark | WorkflowOrder,
  subtitleKey: string
) => {
  switch (componentName) {
    case 'user': {
      return (
        <Text size="lg">
          {`${data['first_name' as keyof typeof data] || ''} ${data['last_name' as keyof typeof data] || ''}`}
        </Text>
      );
    }
    case 'inventory': {
      return (
        <span className="flex space-x-2">
          {!!(data as InventoryAsset).origin && (
            <img
              src="/UPSTACK_logo_black.svg"
              data-testid="upstack-logo"
              className="w-4"
              alt="upstack logo"
            />
          )}
          <Text
            className="self-center"
            size="lg">
            {data[subtitleKey as keyof typeof data]}
          </Text>
        </span>
      );
    }
    default: {
      return <Text size="lg">{data[subtitleKey as keyof typeof data]}</Text>;
    }
  }
};

export const getTitle = (
  title: string | undefined,
  data: InventoryAsset | SupportCasesItem | PortalUserData | Team | AccountData | PriceBenchMark | WorkflowOrder,
  titleKey: string | undefined
) => {
  if (title) return title;
  return data[titleKey as keyof typeof data];
};
